var array = Array.prototype;

export var slice = array.slice;



//////////////////
// WEBPACK FOOTER
// ../~/d3-contour/src/array.js
// module id = TvZ5
// module chunks = 0